import { useState, useEffect } from 'react';
import i18n from '@shared/i18n';

export const usePromoProductDateInfo = (
    promoProductDateInfo: PromoProductDateInfo | undefined
) => {
    const [countdown, setCountdown] = useState('');

    useEffect(() => {
        const updateCountdown = () => {
            const now = new Date();
            const currentDay = now.getDay();
            let targetDate: Date | null = null;

            const fixedDate = promoProductDateInfo?.fixed_date;
            const fixedWeekday = promoProductDateInfo?.fixed_weekday;

            if (fixedDate) {
                const currentDate = now.getDate();
                const currentMonth = now.getMonth();
                const currentYear = now.getFullYear();

                targetDate = new Date(currentYear, currentMonth, fixedDate);

                if (currentDate > fixedDate) {
                    targetDate = new Date(currentYear, currentMonth + 1, fixedDate);
                }
            } else if (fixedWeekday) {
                const daysUntilTarget = (fixedWeekday - currentDay + 7) % 7;

                targetDate = new Date(
                    now.getTime() + daysUntilTarget * 24 * 60 * 60 * 1000
                );
                targetDate.setHours(0, 0, 0, 0);
            }

            if (targetDate) {
                const timeDiff = targetDate.getTime() - now.getTime();

                if (
                    timeDiff <= 0 &&
                    ((promoProductDateInfo?.fixed_date &&
                        now.getDate() === promoProductDateInfo.fixed_date) ||
                        (promoProductDateInfo?.fixed_weekday !== undefined &&
                            currentDay === promoProductDateInfo.fixed_weekday))
                ) {
                    const endOfDay = new Date(targetDate);

                    endOfDay.setHours(23, 59, 59, 999);
                    const remainingTime = endOfDay.getTime() - now.getTime();
                    const hours = Math.floor(remainingTime / (1000 * 60 * 60));
                    const minutes = Math.floor(
                        (remainingTime % (1000 * 60 * 60)) / (1000 * 60)
                    );
                    const seconds = Math.floor((remainingTime % (1000 * 60)) / 1000);

                    setCountdown(
                        `${hours.toString().padStart(2, '0')} : ${minutes.toString().padStart(2, '0')} : ${seconds.toString().padStart(2, '0')}`
                    );
                } else if (timeDiff > 0) {
                    const days = Math.ceil(timeDiff / (1000 * 60 * 60 * 24));

                    setCountdown(`${days} 天`);
                } else {
                    setCountdown('');
                }
            } else {
                setCountdown('');
            }
        };

        updateCountdown();
        const intervalId = setInterval(updateCountdown, 1000);

        return () => clearInterval(intervalId);
    }, [promoProductDateInfo?.fixed_date, promoProductDateInfo?.fixed_weekday]);

    const getDateInfoText = () => {
        if (promoProductDateInfo?.start_datetime && promoProductDateInfo?.end_datetime) {
            if (
                Date.now() >= promoProductDateInfo.start_datetime * 1000 &&
                Date.now() <= promoProductDateInfo.end_datetime * 1000
            ) {
                return i18n
                    .gettext('購買指定商品即可加購優惠品項，活動至 {結束時間} 止')
                    .replace(
                        '{結束時間}',
                        new Date(
                            promoProductDateInfo.end_datetime * 1000
                        ).toLocaleDateString('zh-TW', {
                            month: 'numeric',
                            day: 'numeric',
                            timeZone: 'UTC',
                        })
                    );
            }
        }

        if (
            !promoProductDateInfo?.start_datetime &&
            !promoProductDateInfo?.end_datetime &&
            !promoProductDateInfo?.fixed_weekday &&
            !promoProductDateInfo?.fixed_date
        ) {
            return i18n.gettext('購買指定商品即可加購優惠品項');
        }

        return '';
    };

    return {
        countdown,
        dateInfoText: getDateInfoText(),
    };
};
